import Vue from "vue";
import { Dialog, Toast } from "vant";

export default {
  install(app) {
    Vue.use(Dialog);
    Vue.use(Toast);

    Vue.prototype.$loading = function(obj) {
      if (typeof obj === "string") {
        Toast.loading({ message: obj, forbidClick: true, duration: 0 });
      } else {
        Toast.loading(obj);
      }
    };

    Vue.prototype.$success = Toast.success;
    Vue.prototype.$fail = Toast.fail;
    Vue.prototype.$clear = Toast.clear;
    Vue.prototype.$toast = function(msg) {
      Toast(msg)
    }
  },
};



// WEBPACK FOOTER //
// src/plugin/vant.js